

if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
    }

    get selectedOptionValues() {
      const options = this.querySelectorAll('.m-product-option select, .m-product-option input');
      const selectedValues = new Map();

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          const checkedInput = field.checked ? field : null;
          if (checkedInput) {
            selectedValues.set(fieldName, checkedInput.dataset.optionValueId);
          }
        }

        
      });

      
       // SkuUpdate();
       RewardPoint();
        document.querySelectorAll('.m-quantity__input').forEach(function(input) {
          input.value = 1;
        });

      // single price update
      setTimeout(() => {
       const priceElement = document.querySelector('.appstle_one_time_details_wrapper .appstle_subscription_amount');
       const targetElement = document.querySelector('.single-price-wrap');
        
        if (priceElement && targetElement) {
          targetElement.innerText = priceElement.innerText;
        }
      }, 1000);

      // subscription option change
      // const checkExist = setInterval(() => {
      //   const appstleMianWrapper = document.querySelector('.appstle_subscription_wrapper');
      //   const appstleSelect = document.querySelector('.appstle_select');
      //   if (appstleMianWrapper) {
      //       /* reward point update on frequency select */
      //       appstleSelect.addEventListener('change', function () {
      //         RewardPoint();
      //       });
      
      //       /* reward point and onetime price update on sub type */
      //       document.querySelectorAll('.appstle_subscription_wrapper_option input').forEach(input => {
      //        input.addEventListener('change', function(){
      //              updateOneTimePrice();
      //              RewardPoint();
      //              console.log("gg");
                  

      //          });
      //       });
          
      //       clearInterval(checkExist);
      //   }
      // }, 1000);
      

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (!selectedValues.has(fieldName)) {
          if (field.tagName.toLowerCase() === "select") {
            const firstValidOption = Array.from(field.options).find(
              (opt) => !opt.disabled
            );
            if (firstValidOption) {
              selectedValues.set(
                fieldName,
                firstValidOption.dataset.optionValueId
              );
            }
          } else if (
            field.tagName.toLowerCase() === "input" &&
            field.type === "radio"
          ) {
            const firstInput = field;
            if (firstInput) {
              selectedValues.set(fieldName, firstInput.dataset.optionValueId);
            }
          }
        }
      });

      const result = [];
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (selectedValues.has(fieldName)) {
          const optionValueId = selectedValues.get(fieldName);
          if (optionValueId && !result.includes(optionValueId)) {
            result.push(optionValueId);
          }
        }
      });
      return result;

     
    }

    connectedCallback() {
      this.addEventListener('change', (event) => {
        const target = this.getInputForEventTarget(event.target);
        MinimogEvents.emit(MinimogTheme.pubSubEvents.optionValueSelectionChange, { data: { selectedOptionValues: this.selectedOptionValues, event, target } });
      });
    }

    getInputForEventTarget(target) {
      return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    }
  }
  customElements.define("variant-picker", VariantPicker);
}


setTimeout(() => {
  const priceElement = document.querySelector('.appstle_one_time_details_wrapper .appstle_subscription_amount');
  const targetElement = document.querySelector('.single-price-wrap');
  if(targetElement){
    targetElement.innerText = priceElement ? priceElement.innerText : '';
  }
}, 2000);